isCurrentNodeEpisode